export default {
      id: "ic_header_sync-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic_header_sync-usage",
      toString: function () {
        return this.url;
      }
    }